export default __webpack_public_path__ + "static/WPS-P2P_IN-5907_09-a553639a9fc4735a489de04a81c554dd.webp";